import React, { useContext } from "react";
import { StoreContextMain } from "../../Context/StoreContextMain";
import { CardOrder } from "../../Components/Cards/CardOrder";
import { useNavigate } from "react-router-dom";
import { CardDetailPayment } from "../Components";

export const DetailsPayment = () => {
  const { store } = useContext(StoreContextMain);

  const navigate = useNavigate();

  const handleContinue = () => {
    navigate("/payment/personal-information");
  };

  const getSum = (total, item) => {
    item = Number(item.price)
    return total + item
  }

  return (
    <div className="container mt-3" style={{ background: 'transparent' }}>
      <div className="card">
        <div className="card-header">
          <h5 className="card-title">Detalles de la compra</h5>
        </div>
        <div className="mt-4 row ">
          <div className="col-md-6">
            {store?.map((item, index) => (
              <CardOrder
                key={index}
                id={item.id}
                title={item.title}
                image={item.image}
                price={item.price}
                color={item.color}
                size={item.size}
                amount={item.amount}
                amount_max={item.amount_max}
                enableFeacture={true}
              />
            ))}
          </div>
          <div className="col-md-6">
            <CardDetailPayment
              title="Detalles de la compra"
              totalProducts={store?.length}
              iva={10}
              total={store.reduce(getSum, 0)}
              productsList={store}
            />
          </div>
          <div className="d-flex flex-row justify-content-end mt-3">
            
            <button className="btn btn-primary" onClick={handleContinue}>
              Continuar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
